$(document).on('change', 'select.submit-on-change', function () {
  this.form.submit();
});

$(document).on('change', 'input.submit-on-change', function () {
  this.form.submit();
});
